export default [
    {
        path: "/groupings",
        meta: {
            breadcrumbI18n: "navigation:breadcrumbs.groups.title",
            anchor: "#jumpBreadcrumb"
        },
        component: {
            render(h) {
                return h("router-view");
            }
        },
        children: [
            {
                path: "",
                name: "GroupsSearchPage",
                meta: { keepAlive: true },
                component: () => import("@/components/groupings/GroupsSearchPage.vue")
            },
            {
                path: "new",
                name: "GroupCreationPage",
                component: () => import("@/components/groupings/GroupForm.vue"),
                meta: {
                    breadcrumb: "New",
                    requireAuthorize: true,
                    anchor: "#jumpBreadcrumb"
                }
            },
            {
                path: ":groupId",
                props: true,
                name: "GroupRoot",
                meta: { breadcrumb: { breadcrumbName: "groupName" } },
                redirect: { name: "GroupProfilePage" },
                component: {
                    render(h) {
                        return h("router-view");
                    }
                },
                children: [
                    {
                        path: "",
                        name: "GroupProfilePage",
                        props: true,
                        component: () => import("@/components/groupings/GroupProfilePage.vue"),
                        meta: {
                            breadcrumbI18n: "navigation:breadcrumbs.groupsProfile.title",
                            anchor: "#jumpBreadcrumb"
                        }
                    },
                    {
                        path: "edit",
                        name: "GroupEditForm",
                        component: () => import("@/components/groupings/GroupForm.vue"),
                        props: true,
                        meta: {
                            breadcrumb: "Edit",
                            requireAuthorize: true,
                            anchor: "#jumpBreadcrumb"
                        }
                    }
                ]
            }
        ]
    }
];
